import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import {
  type KeyboardShortcut,
  formatShortcutKey,
} from "@/hooks/use-keyboard-shortcuts"

interface KeyboardShortcutsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  shortcuts: KeyboardShortcut[]
}

export function KeyboardShortcutsModal({
  open,
  onOpenChange,
  shortcuts,
}: KeyboardShortcutsModalProps) {
  const categories = {
    navigation: shortcuts.filter((s) => s.category === "navigation"),
    actions: shortcuts.filter((s) => s.category === "actions"),
    global: shortcuts.filter((s) => s.category === "global"),
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-wide">
            Keyboard Shortcuts
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {categories.navigation.length > 0 && (
            <ShortcutCategory
              title="Navigation"
              shortcuts={categories.navigation}
            />
          )}
          {categories.actions.length > 0 && (
            <ShortcutCategory title="Actions" shortcuts={categories.actions} />
          )}
          {categories.global.length > 0 && (
            <ShortcutCategory title="Global" shortcuts={categories.global} />
          )}
        </div>

        <p className="text-bone-muted mt-4 text-center font-mono text-xs">
          Press <kbd className="bg-bg-hover rounded px-1.5 py-0.5">?</kbd>{" "}
          anytime to see this help
        </p>
      </DialogContent>
    </Dialog>
  )
}

function ShortcutCategory({
  title,
  shortcuts,
}: {
  title: string
  shortcuts: KeyboardShortcut[]
}) {
  return (
    <div>
      <h3 className="text-bone-muted mb-2 font-mono text-xs tracking-wider uppercase">
        {title}
      </h3>
      <div className="space-y-1">
        {shortcuts.map((shortcut) => (
          <div
            key={formatShortcutKey(shortcut) + shortcut.description}
            className="flex items-center justify-between py-1"
          >
            <span className="text-bone text-sm">{shortcut.description}</span>
            <kbd className="bg-bg-hover text-bone-muted rounded px-2 py-1 font-mono text-xs">
              {formatShortcutKey(shortcut)}
            </kbd>
          </div>
        ))}
      </div>
    </div>
  )
}
